import React from 'react'
import './../commonCss/compitionCard.css'
import { Link } from 'react-router-dom'
import CustomPopUp from './CustomPopUp'
import { useTranslate } from './TranslationText'
import JudgeCard from './JudgeCard'

export default function CompitionCard({ data, handleHorseimages }) {
    const { translate } = useTranslate();
    const galleryCheck = !!data?.videoUrl;
    const galleryData = !!data?.videoUrl ? [{ imageUrl: data?.videoUrl }] : [];
    const currentLanguage = localStorage.getItem('ecupLang')??'en';

    return (
        <div className='col-lg-4 col-md-6 col-sm-6 col-12 my-1'>
            <div className='bgGray text-start mx-3 row'>
                <div className='compitionCardHeader roboto-medium text-center' >{data?.championshipName}   {galleryCheck &&
                    <div className='d-inline-block ms-3 border-0 ' style={{ cursor: 'pointer' }} title={translate('web.watchVideo', 'Watch Video')} onClick={(e) => (e.stopPropagation(), handleHorseimages(galleryData))}>
                        <i className="fa-solid fa-film"></i>
                    </div>
                }</div>
                {!!data?.goldHorse?.horseName &&
                    <div className='d-flex align-items-center ps-5'>
                        <div className='cupImageContainer' >
                            <img src='./svgs/cupGold.svg' alt='svg' />
                            <div className='cuprank text-white'>1</div>
                        </div>
                        <div className='ms-3'>{data?.goldHorse?.horseNumber} - {data?.goldHorse?.horseName}</div>
                    </div>
                }
                {!!data?.silverHorse?.horseName &&
                    <div className='d-flex align-items-center ps-5'>
                        <div className='cupImageContainer' >
                            <img src='./svgs/cupSilver.svg' alt='svg' />
                            <div className='cuprank text-white'>2</div>
                        </div>
                        <div className='ms-3'>{data?.silverHorse?.horseNumber} - {data?.silverHorse?.horseName}</div>
                    </div>
                }
                {!!data?.bronzeHorse?.horseName &&
                    <div className='d-flex align-items-center ps-5'>
                        <div className='cupImageContainer' >
                            <img src='./svgs/cup.svg' alt='svg' />
                            <div className='cuprank text-white'>3</div>
                        </div>
                        <div className='ms-3'>{data?.bronzeHorse?.horseNumber} - {data?.bronzeHorse?.horseName}</div>
                    </div>
                }
                {data?.hasScoringDetails == true &&
                    <CustomPopUp
                        trigger={
                            <div className='px-5 roboto-regular greenColor my-3 text-end' style={{ cursor: 'pointer' }} >{translate('web.judgeCard', 'Judge Card')} {currentLanguage=='en'? <i className="ms-1 fa fa-arrow-right"></i>:<i className="ms-1 fa fa-arrow-left"></i>}  </div>
                        }
                        content={<JudgeCard championId={data?.id} />}
                        title={data?.championshipName}
                    />
                }
            </div>
        </div>
    )
}


